import { createDialogStore } from '../createDialogStore';

export const useSaveViewDialog = createDialogStore();
